import React, { useState, useEffect } from 'react';
import Divider from '@mui/material/Divider';
import FormGroup from '@mui/material/FormGroup';
import ExternalViewCommands from './../../services/external';
import TR from './../../Trans';
import MenuItem from '@mui/material/MenuItem';
import ContentContainer from './../items/ContentContainer';
import Link from '@mui/material/Link';
import { Capacitor } from '@capacitor/core';
import { getOS } from './../../services/os';
import InputLabel from '@mui/material/InputLabel';
import RefreshIcon from '@mui/icons-material/Refresh';
import MuvikaService from './../../services/muvika';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import AndroidSubDialog from '../dialogs/AndroidSubDialog';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PinQuestion from '../dialogs/PinQuestion';
import { Views } from './../../enums/enums';
import Waiting from './../items/Waiting';
import FormControlLabel from '@mui/material/FormControlLabel';
import ConfirmPlayerExit from '../dialogs/ConfirmPlayerExit';
import Checkbox from '@mui/material/Checkbox';
import DeleteAccount from '../dialogs/DeleteAccount';
import TextField from '@mui/material/TextField';
import IosExternalLinkDialog from '../dialogs/IosExternalLinkDialog';
import IntervalService from './../../services/intervals';
import navigationStore from '../../stores/navigation';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import accountStore from '../../stores/account';
import messageStore from '../../stores/message';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import EditPerformance from '../dialogs/EditPerformance';
import newTracksStore from './../../stores/newTracks';
import favoritesStore from '../../stores/favorites';
import catalogStore from '../../stores/catalog';
import environmentStore from '../../stores/environment';
import musicStore from '../../stores/music';
import musicPlayerStore from '../../stores/musicPlayer';
import newsStore from '../../stores/news';
import playerStore from '../../stores/player';
import searchStore from '../../stores/search';
import songListStore from '../../stores/songList';
import singerStore from './../../stores/singers';
import timeoutsStore from '../../stores/timeouts';
import statusStore from './../../stores/status';
import homeStore from '../../stores/home';
import SubscribeDialog from '../dialogs/SubscriptionDialog';
import UpdateDialog from './../dialogs/UpdateDialog';
import MessageDialog from './../dialogs/MessageDialog';
import { AndroidExternalScreen } from 'muvika-android-external-screen';
import muvikaAttrs from './../../attrs';
import bgFiltersStore from '../../stores/bgFilters';
import bgStylesStore from '../../stores/bgStyles';
import bgPerformanceStore from '../../stores/bgPerformance';
import bgSearchStore from '../../stores/bgSearch';
import bgPlaylistsStore from './../../stores/bgPlaylists';
import UnsubscribeDialog from './../dialogs/UnsubscribeDialog';
import songbookQueueStore from '../../stores/songbookQueue';
import { validate } from 'uuid';

const pinAttemptTimeout = 60 * 1000;

function resetStores(isWaitingLoggedIn = false) {
  accountStore.getState().reset();
  catalogStore.getState().reset();
  environmentStore.getState().reset();
  favoritesStore.getState().reset();
  messageStore.getState().reset();
  musicPlayerStore.getState().reset();
  musicStore.getState().reset();
  navigationStore.getState().reset();
  newsStore.getState().reset();
  homeStore.getState().reset();
  newTracksStore.getState().reset();
  performanceStore.getState().reset();
  playerStore.getState().reset();
  searchStore.getState().reset();
  sessionStore.setState({
    isSessionOpening: false,
    isThrownOut: false,
    isLoggedIn: false,
    isAckSmartQ: false,
    externalWindowHandler: null,
    isLoginSeqErrors: false,
    isLoginSeqError: false,
    isWaiting: false,
    requestCount: 0,
    isWaitingLoggedIn: isWaitingLoggedIn,
  });
  settingsStore.getState().reset();
  singersStore.getState().reset();
  songListStore.getState().reset();
  timeoutsStore.getState().reset();
  IntervalService.clearAllIntervals();
  IntervalService.clearSongbookInterval();
  IntervalService.clearNewTracksInterval();
  IntervalService.clearSubInterval();
  IntervalService.clearAllStreamUrlTimeouts();
  IntervalService.clearStatusReportInterval();
  bgFiltersStore.getState().reset();
  bgStylesStore.getState().reset();
  bgPerformanceStore.getState().reset();
  bgSearchStore.getState().reset();
  bgPlaylistsStore.getState().reset();
  musicPlayerStore.getState().reset();

}

function Account() {

  const cancellationErrorCode = 123456789;
  const cancellationSuccessCode = 1234567899;

  const [isUnsubscribeDialogOpen, setIsUnsubscribeDialogOpen] = useState(false);

  const goToView = navigationStore((state) => state.goToView);
  const sessionToken = sessionStore((state) => state.sessionToken);
  const setAndroidSubMode = navigationStore((state) => state.setAndroidSubMode);
  const session = sessionStore((state) => state.session);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const setError = messageStore((state) => state.setError);
  const setMessage = messageStore((state) => state.setMessage);
  const isEnvironmentSet = environmentStore((state) => state.isEnvironmentSet);
  const isAccountSet = accountStore((state) => state.isSet);
  const getEnvironment = environmentStore((state) => state.getEnvironment);
  const environment = environmentStore((state) => state.environment);
  const account = accountStore((state) => state.account);
  const getAccount = accountStore((state) => state.getAccount);
  const setAccount = accountStore((state) => state.setAccount);
  const shopVerificationCode = accountStore((state) => state.shopVerificationCode);
  const getShopVerificationCode = accountStore((state) => state.getShopVerificationCode);
  const clearShopVerificationCode = accountStore((state) => state.clearShopVerificationCode);
  const isSaveable = accountStore((state) => state.isSaveable);
  const setSaveable = accountStore((state) => state.setSaveable);
  const setPaddingBottom = navigationStore((state) => state.setPaddingBottom);
  const openSessionAndOneTimeLogin = sessionStore((state) => state.openSessionAndOneTimeLogin);
  const logoutChange = sessionStore((state) => state.logoutChange);
  const logout = sessionStore((state) => state.logout);

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [language, setLanguage] = useState("");
  const [continent, setContinent] = useState("");
  const [country, setCountry] = useState("");
  const [countryState, setCountryState] = useState("");

  const [areNewsletterAccepted, setAreNewsletterAccepted] = useState(false);

  const [address, setAddress] = useState("");
  const [zip, setZip] = useState("");
  const [city, setCity] = useState("");
  const [phone, setPhone] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyBusinessId, setCompanyBusinessId] = useState("");
  const [companyVat, setCompanyVat] = useState("");
  const [office, setOffice] = useState("");

  const [shopUrl, setShopUrl] = useState(null);
  const [isConfirmPlayerExitDialogOpen, setIsConfirmPlayerExitDialogOpen] = useState(false);

  const handleOpenConfirmPlayerExitDialog = () => {
    setIsConfirmPlayerExitDialogOpen(true);
  };

  const handleCloseConfirmPlayerExitDialog = () => {
    setIsConfirmPlayerExitDialogOpen(false);
  };

  const [isDeleteAccountDialogOpen, setIsDeleteAccountDialogOpen] = useState(false);

  const handleOpenDeleteAccountDialog = () => {
    setIsDeleteAccountDialogOpen(true);
  };

  const handleCloseDeleteAccountDialog = () => {
    setIsDeleteAccountDialogOpen(false);
  };

  const [isIosExternalLinkDialogOpen, setIsIosExternalLinkDialogOpen] = useState(false);

  const handleOpenIosExternalLinkDialog = () => {
    setIsIosExternalLinkDialogOpen(true);
  };

  const handleCloseIosExternalLinkDialog = () => {
    setIsIosExternalLinkDialogOpen(false);
  };

  const handleAndroidSubDialogOk = () => {
    console.log("isLoggedAs");
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
      ExternalViewCommands.loadBasicToAndroidExternalScreen();
    } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      ExternalViewCommands.loadBasicToIosExternalScreen();
    }
    logoutChange(account.username, androidSubOneTimeLoginCode);
    setAndroidSubOneTimeLoginCode(null);
    setIsAndroidSubDialogOpen(false);
  };

  const [isAndroidSubDialogOpen, setIsAndroidSubDialogOpen] = useState(false);
  const [androidSubOneTimeLoginCode, setAndroidSubOneTimeLoginCode] = useState(null);

  const handleOpenAndroidSubDialog = () => {
    MuvikaService.createAccountLink(sessionToken, account.username, "one_time_login")
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
        } else {
          setAndroidSubOneTimeLoginCode(res.data.data.code);
          setIsAndroidSubDialogOpen(true);
          setAndroidSubMode(true);
        }
      })
      .catch(function () { });
  };

  const handleCloseAndroidSubDialog = () => {
    setIsAndroidSubDialogOpen(false);
    setAndroidSubMode(false);
  };

  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const [isPinQuestionOpen, setIsPinQuestionOpen] = useState(true);
  const [isPinChecked, setIsPinChecked] = useState(false);

  const [wrongPinAttempts, setWrongPinAttempts] = useState(0);
  const timeoutPinAttempts = () => {
    setTimeout(() => setWrongPinAttempts(0), pinAttemptTimeout);
  };

  const logoutNow = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
      ExternalViewCommands.loadBasicToAndroidExternalScreen();
    } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      ExternalViewCommands.loadBasicToIosExternalScreen();
    }
    logout();
  };

  const handleDeleteAccount = (password) => {
    if (password.length > 0) {
      MuvikaService.deleteAccount(sessionToken, account.username, password)
        .then(function (res) {
          if (res.data.error) {
            setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            handleCloseDeleteAccountDialog();
            resetStores();
            logoutNow();
          }
        })
        .catch(function () { });
    } else {
      setError(sessionToken, 0, TR.ww_set_password);
    }
  };

  const handleRefresh = () => {
    getAccount(sessionToken);
    getSettings(sessionToken);
    forceUpdate();
  };

  useEffect(() => {
    if (!settings) {
      getSettings(sessionToken);
    }
    if (!environment) {
      getEnvironment(sessionToken);
    }
    getAccount(sessionToken);
    setSaveable(false);
  }, []);

  useEffect(() => {
    if (account) {
      setUsername(account.username);
      setEmail(account.email);
      setFirstname(account.firstname);
      setLastname(account.lastname);
      setLanguage(account.language);
      setCountry(account.country_code);
      setCountryState(account.state_or_province_code);
      setAreNewsletterAccepted(account.allow_newsletter);
      if (!isCustomer(account.tags)) {
        setAddress(account.address);
        setZip(account.zip);
        setCity(account.city);
        setPhone(account.phone);
        if (account.company) {
          setCompanyName(account.company.name);
          setCompanyBusinessId(account.company.business_id);
          setCompanyVat(account.company.vat_number);
        }
        setOffice(account.office_name);
      }
    }
  }, [account]);

  useEffect(() => {
    if (environment && account) {
      if (continent.length == 0) {
        let continentCountry = environment.countries.find(x => x.code == account.country_code);
        setContinent(continentCountry ? continentCountry.continent_code : "");
      }
    }
  });

  const handleOpenUnsubscribeDialog = () => {
    setIsUnsubscribeDialogOpen(true);
  };

  const handleCloseUnsubscribeDialog = () => {
    setIsUnsubscribeDialogOpen(false);
  };

  const handleCheckPin = (pin) => {


    if (pin === settings.account_pin) {
      setIsPinChecked(true);
    } else {
      if (wrongPinAttempts == 0) {
        timeoutPinAttempts();
      }
      if (wrongPinAttempts >= 4) {
        setError(sessionToken, 0, TR.cm_too_many_failed_attempts_try_later);
      } else {
        setError(sessionToken, 0, TR.cm_invalid_pin);
      }
      setWrongPinAttempts(wrongPinAttempts + 1);
    }
  };

  const handleOpenPinQuestion = () => {
    setIsPinQuestionOpen(true);
  };

  const handleClosePinQuestion = () => {
    setIsPinQuestionOpen(false);
    goToView(Views.Home);
  };

  const handleCancellation = (feedback) => {


    setIsUnsubscribeDialogOpen(false);
    MuvikaService.cancelSubscription(sessionToken, account.subscription.order_info.id)
      .then(function (res) {
        if (res.data.error) {
          setIsUnsubscribeDialogOpen(false);
          setError(sessionToken, cancellationErrorCode, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          if (feedback.length > 0) {
            MuvikaService.sendFeedback(sessionToken, "cancel_reason", feedback)
              .then(function (res) {
                if (res.data.error) {
                  setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                } else {
                  setMessage(sessionToken, TR.cm_feedback_saved_thanks);
                }
              })
              .catch(function () { });
          }
          setIsUnsubscribeDialogOpen(false);
          getAccount(sessionToken);
          setMessage(sessionToken, TR.cm_subscription_cancelled);
        }
      })
      .catch(function () { });
  };

  const isCustomer = (tags) => {
    if (tags) {
      return tags.includes("consumer");
    }
    return false;
  };

  const saveAccount = () => {
    let newAccount = { ...account };
    newAccount.email = email;
    newAccount.firstname = firstname;
    newAccount.lastname = lastname;
    newAccount.language = language;
    newAccount.country_code = country;
    newAccount.allow_newsletter = areNewsletterAccepted;
    if (countryState) {
      if (countryState.length > 0) {
        newAccount.state_or_province_code = countryState;
      }
    }
    if (!isCustomer(account.tags)) {
      newAccount.address = address;
      newAccount.zip = zip;
      newAccount.city = city;
      newAccount.phone = phone;
      newAccount.office_name = office;
      newAccount.company = {
        name: companyName,
        business_id: companyBusinessId,
        vat_number: companyVat
      };
    }
    setAccount(sessionToken, newAccount);
    setSaveable(false);
    setPaddingBottom("muvika-account", 0);
  };

  const handleLanguageChange = (event) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setLanguage(event.target.value);
  };

  const handleContinentChange = (event) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setContinent(event.target.value);
    let firstCountry = environment.countries.find(x => x.continent_code === event.target.value);
    setCountry(firstCountry.code);
    let state = environment.states_or_provinces.find(x => x.country_code === firstCountry.code);
    if (state) {
      setCountryState(state.code);
    }
  };

  const handleCountryChange = (event) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setCountry(event.target.value);
    let state = environment.states_or_provinces.find(x => x.country_code === event.target.value);
    if (state) {
      setCountryState(state.code);
    }
  };

  const handleCountryStateChange = (event) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setCountryState(event.target.value);
  };

  const listLanguages = () => {
    if (environment) {
      return environment.languages.map((language) =>
        <MenuItem key={language} value={language}>{language == "Finnish" ? TR.cm_lang_finnish : language}</MenuItem>
      );
    }
  };

  const listContinents = () => {
    if (environment) {
      return environment.continents.map((continent) =>
        <MenuItem key={continent.code} value={continent.code}>{continent.name}</MenuItem>
      );
    }
  };


  const listCountries = () => {
    if (environment && continent.length > 0) {
      return environment.countries.map((country) => {
        if (country.continent_code === continent) {
          return <MenuItem key={country.code} value={country.code}>{country.name}</MenuItem>;
        }
      }
      );
    }
  };

  const listCountryStates = () => {
    if (environment && country) {
      return environment.states_or_provinces.map((countryState) => {
        if (countryState.country_code === country) {
          return <MenuItem key={countryState.code} value={countryState.code}>{countryState.name}</MenuItem>;
        }
      }
      );
    }
  };

  const selectContinents = () => {
    return <Select className="muvika-select"
      defaultValue={continent}
      onChange={handleContinentChange}
    >
      {listContinents()}
    </Select>;
  };

  const selectCountries = () => {
    if (continent.length > 0) {
      return <FormGroup>
        <InputLabel>{TR.cm_country}</InputLabel>
        <Select className="muvika-select"
          value={country}
          onChange={handleCountryChange}
        >
          {listCountries()}
        </Select>
      </FormGroup>;
    }
  };

  const selectCountryStates = () => {
    if (country.length > 0) {
      let isStates = environment.states_or_provinces.find(x => x.country_code === country);
      if (isStates) {
        return <FormGroup>
          <InputLabel>{TR.cm_state_or_province}</InputLabel>
          <Select className="muvika-select"
            value={countryState}
            onChange={handleCountryStateChange}
          >
            {listCountryStates()}
          </Select>
        </FormGroup>;
      }
    }
  };

  const handleOfficeChange = (e) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setOffice(e.target.value);
  };

  const handleCompanyChange = (e) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setCompanyName(e.target.value);
  };

  const handleCompanyBusinessIdChange = (e) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setCompanyBusinessId(e.target.value);
  };

  const handleCompanyVatChange = (e) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setCompanyVat(e.target.value);
  };

  const handleAddressChange = (e) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setAddress(e.target.value);
  };

  const handleZipChange = (e) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setZip(e.target.value);
  };

  const handleCityChange = (e) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setCity(e.target.value);
  };

  const handlePhoneChange = (e) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setPhone(e.target.value);
  };

  const handleNewsletterSet = (e) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setAreNewsletterAccepted(e.target.checked);
  };

  const renderPro = () => {
    if (account) {
      if (!isCustomer(account.tags)) {
        return <FormGroup>
          <Stack spacing={2}>
            <InputLabel>{TR.cm_office}</InputLabel>
            <TextField
              defaultValue={account.office_name}
              size="small"
              onChange={handleOfficeChange}
            />
            <InputLabel>{TR.cm_company}</InputLabel>
            <TextField
              value={companyName}
              size="small"
              onChange={handleCompanyChange}
            />
            <InputLabel>{TR.cm_business_id}</InputLabel>
            <TextField
              value={companyBusinessId}
              size="small"
              onChange={handleCompanyBusinessIdChange}
            />
            <InputLabel>{TR.cm_tax_number}</InputLabel>
            <TextField
              value={companyVat}
              size="small"
              onChange={handleCompanyVatChange}
            />
            <InputLabel>{TR.cm_address}</InputLabel>
            <TextField
              value={address}
              size="small"
              onChange={handleAddressChange}
            />
            <InputLabel>{TR.cm_zip}</InputLabel>
            <TextField
              value={zip}
              size="small"
              onChange={handleZipChange}
            />
            <InputLabel>{TR.cm_city}</InputLabel>
            <TextField
              value={city}
              size="small"
              onChange={handleCityChange}
            />
            <InputLabel>{TR.cm_phone}</InputLabel>
            <TextField
              value={phone}
              size="small"
              onChange={handlePhoneChange}
            />
          </Stack>
        </FormGroup>;
      }
    }
  };

  const goToShop = (sessionToken, accountId, email, url) => {


    MuvikaService.createAccountLink(sessionToken, email, "one_time_login")
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
        } else {
          window.open(url + "?origin=muvikaweb&id=" + accountId + "&login_code=" + res.data.data.code, "_self");
        }
      })
      .catch(function () { });
  };

  const handleButtonSubscribe = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      handleOpenIosExternalLinkDialog();
    } else if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
      handleOpenAndroidSubDialog();
    } else {
      if (isCustomer(account.tags)) {
        goToShop(sessionToken,
          account.account_id,
          account.username,
          session.urls.url_subscribe
        );
      } else {
        setShopUrl(session.urls.url_subscribe);
        handleOpenConfirmPlayerExitDialog();
      }
    }
  };

  const handleButtonUpdateCard = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      handleOpenIosExternalLinkDialog();
    } else {
      if (isCustomer(account.tags)) {
        goToShop(sessionToken,
          account.account_id,
          account.username,
          session.urls.url_update_card
        );
      } else {
        setShopUrl(session.urls.url_update_card);
        handleOpenConfirmPlayerExitDialog();
      }
    }
  };

  const handleButtonViewPayments = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      handleOpenIosExternalLinkDialog();
    } else {
      if (isCustomer(account.tags)) {
        goToShop(sessionToken,
          account.account_id,
          account.username,
          session.urls.url_view_payments
        );
      } else {
        setShopUrl(session.urls.url_view_payments);
        handleOpenConfirmPlayerExitDialog();
      }
    }
  };

  const subscriptionButtons = () => {
    if (account && session) {
      let actions = account.subscription.order_info.actions;
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
        return actions.map((action) => {
          switch (action) {
            case "subscribe":
              return <Button key={action} onClick={handleButtonSubscribe} variant="text" color="success">{TR.cm_renew_subs}</Button>;
              break;
            case "unsubscribe":
              return <Button key={action} onClick={handleOpenUnsubscribeDialog} variant="text" color="secondary">{TR.cm_cancel_subs}</Button>;
              break;
          }
        });
      } else {
        return actions.map((action) => {
          switch (action) {
            case "subscribe":
              return <Button key={action} onClick={handleButtonSubscribe} variant="text" color="success">{TR.cm_renew_subs}</Button>;
              break;
            case "unsubscribe":
              return <Button key={action} onClick={handleOpenUnsubscribeDialog} variant="text" color="secondary">{TR.cm_cancel_subs}</Button>;
              break;
            case "update_card":
              return <Button key={action} onClick={handleButtonUpdateCard} variant="text" color="success">{TR.cm_update_payment_card}</Button>;
              break;
            case "view_payments":
              return <Button key={action} onClick={handleButtonViewPayments} variant="text" color="success">{TR.cm_transactions}</Button>;
              break;
          }
        });
      }
    }
  };

  const giftCardLink = () => {
    let actions = account.subscription.order_info.actions;
    if (actions.includes("go_to_shop")) {
      return <p>
        {TR.cm_go_to_shop_question} <Link className="muvika-link-rem-nodec" onClick={handleButtonSubscribe} variant="body2">
          {TR.cm_go_to_shop}
        </Link>
      </p>;
    }
  };

  const subscriptionDetails = () => {
    if (account) {
      let statusMsg = account.subscription.order_info.status_msg;
      let paymentMethod = account.subscription.order_info.payment_type_name;
      let paymentError = account.subscription.order_info.failure_msg;
      return <div>
        <p>
          {TR.cm_current_subscription}: {account.subscription.order_info.status_msg}
        </p>
        <p>
          {paymentMethod.length > 0 ? (TR.cm_payment_method + ": " + paymentMethod) : ""}
        </p>
        <p>
          {paymentError.length > 0 ? (TR.cm_error + ": " + paymentError) : ""}
        </p>
      </div>;
    }
  };

  const handleEmailChange = (e) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setEmail(e.target.value.toLowerCase());
  };

  const handleFirstnameChange = (e) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setFirstname(e.target.value);
  };

  const handleLastnameChange = (e) => {


    setSaveable(true);
    setPaddingBottom("muvika-account", -45);
    setLastname(e.target.value);
  };

  const renderDeleteButton = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      if (account) {
        if (account.subscription.order_info.actions.includes("subscribe")) {
          return <Button onClick={handleOpenDeleteAccountDialog} variant="text" color="warning">{TR.cm_delete_account}</Button>;
        }
      }
    }
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const renderEmailField = () => {
    if (username) {
      if (!validateEmail(username)) {
        return <div style={{ width: "100%" }}>
          <InputLabel>{TR.cm_email}</InputLabel>
          <TextField
            style={{ width: "100%" }}
            onChange={handleEmailChange}
            value={email}
            size="small"
          />
        </div>;
      }
    }
  };

  const accountForm = () => {
    if (environment && account && continent.length > 0) {
      return <ContentContainer id="muvika-account" onScrollDown={() => {
      }} isFinished={true}>
        <h3>
          {TR.cm_subscription_info}
        </h3>
        <Stack className="muvika-account-subscription">
          {subscriptionDetails()}
          <Stack sx={{ flexDirection: { md: "column", lg: "row" } }} spacing={0} justifyContent="left">
            {subscriptionButtons()}
          </Stack>
          {giftCardLink()}
        </Stack>
        <h3 className="muvika-account-title">{TR.cm_my_account}</h3>
        <FormGroup className="muvika-account-form">
          <Stack spacing={2}>
            <InputLabel>{TR.cm_username}</InputLabel>
            <TextField
              value={username}
              size="small"
              disabled
            />
            {renderEmailField()}
            <InputLabel>{TR.cm_firstname}</InputLabel>
            <TextField
              id="muvika-account-firstname"
              onChange={handleFirstnameChange}
              value={firstname}
              size="small"
            />
            <InputLabel>{TR.cm_lastname}</InputLabel>
            <TextField
              onChange={handleLastnameChange}
              value={lastname}
              size="small"
            />
            <InputLabel>{TR.cm_language}</InputLabel>
            <Select className="muvika-select"
              label={TR.cm_language}
              value={language}
              onChange={handleLanguageChange}
            >
              {listLanguages()}
            </Select>
            <InputLabel>{TR.cm_area}</InputLabel>
            {selectContinents()}
            {selectCountries()}
            {selectCountryStates()}
            {renderPro()}
            <p>
              <FormControlLabel onChange={handleNewsletterSet} required control={<Checkbox defaultChecked={areNewsletterAccepted} />} />
              <span>
                {TR.cm_allow_newsletter}
              </span>
            </p>
            <p></p>
          </Stack>
        </FormGroup>
        {renderDeleteButton()}
      </ContentContainer>;
    }
  };

  const waitingRender = () => {
    if (account) {
      return accountForm();
    } else {
      return <Waiting />;
    }
  };

  const renderSaveButton = () => {
    if (isSaveable) {
      return <div className="muvika-save-div">
        <Button className="muvika-save-button" variant="text" color="success" onClick={
          saveAccount
        }>{TR.cm_save}
        </Button>
      </div>;
    }
  };

  const renderPinDialogOrForm = () => {
    if (settings) {
      if (settings.account_pin && !isPinChecked) {
        return <PinQuestion open={isPinQuestionOpen} onClose={handleClosePinQuestion} onCheckPin={handleCheckPin} />;
      } else {
        return <div>
          <ConfirmPlayerExit
            open={isConfirmPlayerExitDialogOpen}
            onClose={handleCloseConfirmPlayerExitDialog}
            onConfirmation={() => {
              goToShop(sessionToken,
                account?.account_id,
                account?.username,
                shopUrl
              );
            }}
          />
          <DeleteAccount
            open={isDeleteAccountDialogOpen}
            onClose={handleCloseDeleteAccountDialog}
            onDeleteAccount={handleDeleteAccount}
          />
          <AndroidSubDialog
            open={isAndroidSubDialogOpen}
            onClose={handleCloseAndroidSubDialog}
            onOk={handleAndroidSubDialogOk}
          />
          <IosExternalLinkDialog
            open={isIosExternalLinkDialogOpen}
            onClose={handleCloseIosExternalLinkDialog}
            message={TR.cm_external_link_account_ios}
            url={"https://muvika.com"}
          />
          <UnsubscribeDialog
            open={isUnsubscribeDialogOpen}
            onClose={handleCloseUnsubscribeDialog}
            onCancellation={handleCancellation}
          />
          {waitingRender()}
          {renderSaveButton()}
        </div>;
      }
    }
  };

  return (
    <div>
      {renderPinDialogOrForm()}
    </div>
  );
};

export default Account;